import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const PortfolioSingle = () => {

  // Get Portfolio details passed via router state
  const location = useLocation();
  const portfolio = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={portfolio.title} page={"Portfolio Single"} />

      <section className='portfolio-single page-single'>

        <div className='portfolio-info page-info'>

          {/* Portfolio Image */}
          <div className='image'>
            <img src={portfolio.image} alt={portfolio.title} />
          </div>

          <div className='content'>

            {/* Portfolio Title */}
            <h3 className='main-heading'>{portfolio.title}</h3>

            {/* Portfolio Description */}
            {portfolio.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Portfolio Image Gallery */}
            <Lightbox images={portfolio.gallery} />

            {/* Client Requirements Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Client Requirements:</h3>
              <p>Specific needs, preferences, and objectives outlined by the client for {portfolio.title}:</p>

              {/* List of Client Requirements */}
              <ul>
                {portfolio.requirements.map((requirement, index) => {
                  return <li key={index}><FaCaretRight className='icon' />{requirement}</li>
                })}
              </ul>

            </div>

            {/* Our Approach Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Our Approach:</h3>
              <p>How we planned and executed {portfolio.title} with a client-focused strategy:</p>

              {/* Our Approach List */}
              <ul>
                {portfolio.approach.map((item, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{item}</li>
                })}
              </ul>

            </div>

            {/* Tour Highlights Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Tour Highlights:</h3>
              <p>Key attractions, experiences, and memorable moments from {portfolio.title}:</p>

              {/* Tour Highlights */}
              <ul>
                {portfolio.highlights.map((highlight, index) => {
                  return <li key={index}><FaCheck className='icon' />{highlight}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Portfolio details */}
        <PageSidebar
          heading={'Portfolio'}
          details={portfolio.details}
        />

      </section>

    </> 
  );
}

export default PortfolioSingle;